import { fetchDocuments } from '../../../../actions';
import { processDocuments } from '../../../../services';
import { getFileTypeName } from '../../../../utils';

/**
 * API'den belgeleri getir ve işle
 * 
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @param {Function} filterDocuments - Belgeleri filtreleme fonksiyonu
 * @returns {Function} - Belgeleri yükleme fonksiyonu
 */
export const createLoadDocumentsMethod = (state, services, filterDocuments) => {
  const {
    allDocuments,
    documents,
    isLoadingDocuments,
  } = state;

  const {
    assetStore,
    axios,
    settings, 
    responseHandlerService,
  } = services;

  /**
   * API'den belgeleri getir
   */
  return async () => {
    isLoadingDocuments.value = true;
    documents.value = []; // Önce belgeleri temizle

    try {
      // API'den belgeleri getir (filtresiz)
      const rawDocuments = await fetchDocuments({
        axios,
        settings,
        assetId: assetStore.assetId,
      });

      // Servis ile belgeleri işle
      const getFileTypeFn = services.getFileTypeName || getFileTypeName;
      allDocuments.value = processDocuments(rawDocuments, getFileTypeFn);

      // Belgeleri frontend'de filtrele
      filterDocuments();

    } catch (error) {
      allDocuments.value = [];
      documents.value = [];
      responseHandlerService.handleError(error, 'Belgeler yüklenirken bir hata oluştu');
    } finally {
      isLoadingDocuments.value = false;
    }
  };
};